import { useRef } from "react";
import NavItem from "./NavItem";
import { useKeyboardNavigation } from "../hooks/useAccessibility";

function NavGroup({ group, isOpen, onOpen, onClose }) {
  const triggerRef = useRef(null);

  const { onKeyDown } = useKeyboardNavigation({
    onEscape: () => {
      onClose();
      triggerRef.current?.focus();
    },
  });

  return (
    <div
      className="relative"
      onMouseEnter={() => onOpen(group.id)}
      onMouseLeave={onClose}
      onKeyDown={onKeyDown}
    >
      <button
        ref={triggerRef}
        onFocus={() => onOpen(group.id)}
        aria-haspopup="true"
        aria-expanded={isOpen}
        className={`flex items-center gap-1 px-3 py-2 rounded-xl text-sm font-medium transition-colors duration-150 ${
          isOpen
            ? "text-text-primary bg-bg-secondary"
            : "text-text-secondary hover:text-text-primary hover:bg-bg-secondary"
        }`}
      >
        {group.label}
        <svg
          className={`w-3.5 h-3.5 transition-transform duration-150 ${isOpen ? "rotate-180" : ""}`}
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          aria-hidden="true"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M19 9l-7 7-7-7"
          />
        </svg>
      </button>

      {isOpen && (
        <>
          <div className="absolute top-full left-0 w-full h-2" />
          <div className="absolute top-full left-0 mt-2 w-48 bg-card-bg rounded-xl shadow-lg border border-card-border py-1 z-50">
            {group.items.map((item) => (
              <NavItem key={item.path} path={item.path} label={item.label} onClick={onClose} />
            ))}
          </div>
        </>
      )}
    </div>
  );
}

export default NavGroup;
